import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'

import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  EstablishEntityIBANsClientRequest,
  EstablishEntityIBANsClientResponse,
} from '../../../@types/establishEntityIbans'
import { api } from '../../../Services/API'
import { useEstablishEntityIbansStore } from '../../../Stores/useEstablishEntityIbansStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: EstablishEntityIBANsClientRequest) => {
  const response = await api.post<EstablishEntityIBANsClientResponse>(
    API_ROUTES.establishEntityIbans,
    payload,
  )

  return response.data
}

export const useEstablishEntityIbans = () => {
  const { setEstablishEntityIbans } = useEstablishEntityIbansStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: EstablishEntityIBANsClientRequest) =>
      request(payload!),
    onSuccess(data) {
      setEstablishEntityIbans(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
